import React from 'react';
import { Smile, Meh, Frown } from 'lucide-react';

interface RatingIconProps {
  readonly isSelected: boolean;
}

export function HappyIcon({ isSelected }: RatingIconProps): React.ReactElement {
  return (
    <Smile
      className={`h-5 w-5 ${isSelected ? 'text-green-500' : 'text-current'}`}
    />
  );
}

export function MehIcon({ isSelected }: RatingIconProps): React.ReactElement {
  return (
    <Meh
      className={`h-5 w-5 ${isSelected ? 'text-orange-500' : 'text-current'}`}
    />
  );
}

export function UnhappyIcon({
  isSelected
}: RatingIconProps): React.ReactElement {
  return (
    <Frown
      className={`h-5 w-5 ${isSelected ? 'text-red-500' : 'text-current'}`}
    />
  );
}
